var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLoanAndCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 72,
    viewBox: "0 0 220 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C16.212 18.6771 36.9713 35.1813 70.3127 31.7812C103.654 28.3812 110.634 49.8438 109.957 61",
    stroke: "#FFF8CD",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210 10C203.788 18.6771 183.029 35.1813 149.687 31.7812C116.346 28.3812 109.366 49.8438 110.043 61",
    stroke: "#E7F0FE",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.001 59.683C100.001 59.6524 100.001 59.6217 100.001 59.5909C100.018 52.14 102.391 42.2683 109.749 34.2704C109.832 34.1799 109.916 34.0897 110 34C110.084 34.0897 110.168 34.1799 110.251 34.2704C117.609 42.2683 119.982 52.14 119.999 59.5909C119.999 59.6217 119.999 59.6524 119.999 59.683C119.999 60.3832 119.978 61.0617 119.938 61.715C119.617 67.0098 115.231 71.0913 110 71.109C104.769 71.0913 100.384 67.0098 100.062 61.715C100.022 61.0617 100.001 60.3832 100.001 59.683Z",
    fill: "#EAF8E5",
    fillOpacity: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLoanAndCard);
export default __webpack_public_path__ + "static/media/arrow-loan-and-card.7d6283fefda4e3299b3b1d149a6de212.svg";
export { ForwardRef as ReactComponent };